<template>
    <div>
        <div class="app-title">
            <div>
                <h2>Bin位码打印</h2>
            </div>
        </div>
        <section class="app-content">
            <el-form :inline="true" :model="entity" class="demo-form-inline">
                <table>
                    <tr>
                        <th>
                            <el-form-item :label="entity.printType==='package'? 'projectCode' :'Location'">
                                <el-input v-model="entity.storageLoc"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item :label="entity.printType==='package'? 'packageNo' :'Type'">
                                <el-input v-model="entity.storageType"></el-input>
                            </el-form-item>
                        </th>
                        <th>
                            <el-form-item :label="entity.printType==='package'? 'boxNo' :'Bin'">
                                <el-input v-model="entity.storageBin"></el-input>
                            </el-form-item>
                        </th>
                        <th style="vertical-align: top;text-align: center;">
                            <el-button @click="printCustomLabel">打印</el-button>
                        </th>
                    </tr>
                </table>
            </el-form>
        </section>
    </div>
</template>

<script>

    export default {
        name: 'sithMesInventoryBinAddPrint',

        data() {
            return {
                entity: {
                    'storageLoc': '',
                    'storageType': '',
                    'storageBin': '',
                }
            }
        },
        components: {},
        computed: {},
        methods: {
            printCustomLabel() {
                this.$router.push({
                    name: 'sithMesInventoryBinPrint',
                    query: this.entity
                });
            }
        },
        created() {
        },
        mounted() {
            if( this.$route.params.storageLoc) {
                this.entity.storageLoc = this.$route.params.storageLoc;
            }
            if(this.$route.params.storageType) {
                this.entity.storageType = this.$route.params.storageType;
            }
            if(this.$route.params.storageBin) {
                this.entity.storageBin = this.$route.params.storageBin;
            }
            if(this.$route.params.printType) {
                this.entity.printType = this.$route.params.printType;
            }
            if(this.$route.params.packageId) {
                this.entity.packageId = this.$route.params.packageId;
            }
        }
    };
</script>
<style>
    label {
        width: 120px;
    }

    textarea {
        min-height: 40px;
    }
</style>
